"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneTypes = void 0;
exports.PhoneTypes = {
    office: 1,
    mobile: 2,
    home: 4,
    fax: 5,
    other: 8,
};
